<!--Info-->
<div class="InfoGrid">
	<h4>Group Name:</h4>
	<h4 class="InfoText">{{ GroupName }}</h4>
</div>

<!--Group Actions-->
<div class="SubMenu">
	<h4>Select Group Actions to Remove:</h4>
	<label>These will be deleted from the selected students.</label>

	<div class="TopMargin">
		<caass-actions-to-remove [SelectedGroup]="SelectedGroup"> </caass-actions-to-remove>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUnassign()">Unassign</button>
	<button class="btn btn-primary" (click)="onCancel()">Cancel</button>
</div>
